import request from '../utils/request';
// 展品部分

// 筛选展品
export function searchExhibits(data) {
  return request({
    url: '/onlineExhibition/exhibitSearch',
    method: 'POST',
    data: data,
  });
}
// 展品详情
export function getExhibit(data) {
  return request({
    url: '/onlineExhibition/exhibitDetails',
    method: 'get',
    params: data,
  });
}
// 获取展商信息
export function getExhibitor(data) {
  return request({
    url: '/onlineExhibition/exhibitorDetails',
    method: 'get',
    params: data,
  });
}

// 其他展品信息
export function getOtherEx(data) {
  return request({
    url: '/onlineExhibition/otherExhibits',
    method: 'get',
    params: data,
  });
}

//展品收藏
export function collecExhibit(data) {
  return request({
    url: '/onlineExhibition/addCollect',
    method: 'get',
    params: data,
  });
}
